export default __webpack_public_path__ + "static/media/pause-quit-confirm.75804836.png";